import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getCompareValue'
})
export class GetCompareValuePipe implements PipeTransform {

  transform(value: string, compareValue: string): boolean {
    if (!value || !compareValue || !compareValue['iv']) {
      return false;
    }
    return value === compareValue['iv'];
  }

}
